import { Sliders } from './sliders';
import { Menu } from './menu';
import { OffcanvasMenu } from './offcanvasMenu';
import { heroAnimations } from './heroAnimations';
import { heroHomeAnimations } from './heroHomeAnimations';
import { menuAnimations } from './menuAnimations';
import { trendsAnimations } from './trendsAnimations';
import { videoBoxAnimations } from './videoBoxAnimations';
import { fastProjects } from './fastProjects';
import { numbersCounter } from './numbersCounter';
import { generalElementAnimations } from './generalElementAnimations';
import { expertiseAreas } from './expertiseAreas';
import { helpsElementAnimations } from './helpsElementAnimations';
import { helpsCardsToggle } from './helpsCardsToggle';
import { servicesBoxToggle } from './servicesBoxToggle';
import { searchModal } from './searchModal';
import { imageTextAnimations } from './imageTextAnimations';
import { servicesBoxAnimations } from './serviceBoxAnimations';
import { numbersAnimations } from './numbersAnimations';


// ========= Helpers fissi =========
const anchorScroll = () => {
  document.addEventListener('DOMContentLoaded', function() {
    const menuHeight = 128;
    const menuLinks = document.querySelectorAll('.anchor-link');
    menuLinks.forEach(link => {
      link.addEventListener('click', function(event) {
        const href = this.getAttribute('href');
        if (!href || !href.startsWith('#')) return;
        const target = document.querySelector(href);
        if (!target) return;

        event.preventDefault();
        const top = target.offsetTop - menuHeight;
        window.scrollTo({ top, behavior: 'smooth' });
      });
    });
  });
};

const modalFix = () => { 
  document.addEventListener('shown.bs.modal', () => {
    document.documentElement.classList.add('modal-open');
  });
  document.addEventListener('hidden.bs.modal', () => {
    document.documentElement.classList.remove('modal-open');
  });  
};

// ========= Bootstrap =========
anchorScroll();
modalFix();

// Esegui ogni funzione solo se trova il suo elemento
if (document.querySelector('.offcanvas-menu')) OffcanvasMenu();
if (document.querySelector('.site-header')) Menu();

if (document.querySelector('.hero')) heroAnimations();
if (document.querySelector('.hero-home')) heroHomeAnimations();
if (document.querySelector('.video-box')) videoBoxAnimations();
if (document.querySelector('.trends')) trendsAnimations();
if (document.querySelector('.site-header')) menuAnimations();

if (document.querySelector('.fast-projects')) fastProjects();
if (document.querySelector('.services-box')) servicesBoxAnimations();
if (document.querySelector('.services-box')) servicesBoxToggle();

if (document.querySelector('.search-modal')) searchModal();
if (document.querySelector('.image-text')) imageTextAnimations();

if (document.querySelector('.js-slider')) Sliders();
if (document.querySelector('.text-content, .feature-image, [class$="__main-title"]')) generalElementAnimations();
if (document.querySelector('.expertise-areas')) expertiseAreas();

if (document.querySelector('.js-animate-number')) {
  numbersAnimations();
  numbersCounter();
}

if (document.querySelector('.helps-pages')) {
  helpsElementAnimations();
  helpsCardsToggle();
}